import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import { getEntity } from "data/entity";
import {
  getAllocations,
  getCentralizedGifts,
  getConfirming,
  getFormSubmitting,
} from "data/giving-form/allocation-selection";
import CentralizedGifts from "./CentralizedGifts";

import classNames from "classnames";

export class Funds extends Component {
  render() {
    const {
      entity,
      confirming,
      setAddingGift,
      formSubmitting,
      currencySymbol,
      allocations,
      formIsValid,
      hasConfirmationStep,
      handleFundAdded,
      handleConfirm,
      handleSubmit,
      updateAllocationsAmountWithGifts,
      resetCentralizedGifts,
      handleCloseModal,
      centralizedGifts,
    } = this.props;

    if (centralizedGifts.size === 0) {
      hasConfirmationStep ? handleConfirm() : handleSubmit();
    }

    const displayFundsStep =
      confirming && hasConfirmationStep && centralizedGifts.length > 0
        ? "none"
        : "inherit";

    return (
      <section
        className="Modal__Content donate-modal primary-color-background"
        style={{ display: displayFundsStep }}>
        <div className="voting-modal-background">
          <button
            data-testid="t-Funds-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button"
            onClick={handleCloseModal}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              {entity.get("donation_modal_header") ? (
                entity.get("donation_modal_header")
              ) : (
                <span>
                  <FormattedMessage id="giftInformation" /> &gt;{" "}
                  <span className="step-active">
                    <FormattedMessage id="payment" />
                  </span>
                  {hasConfirmationStep ? (
                    <span>
                      {" "}
                      &gt; <FormattedMessage id="confirmation" />
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              )}
            </h2>
            <span className="white-font-color" />
          </div>
          <div className="voting-modal-body funds-modal-body">
            <div className="donating-steps">
              <i
                className="donate-back-button primary-color-text pointer"
                onClick={() => {
                  setAddingGift(false);
                }}
              />
            </div>
            <div className="text-center">
              <CentralizedGifts
                currencySymbol={currencySymbol}
                centralizedGifts={centralizedGifts}
                onFundAdded={handleFundAdded}
              />

              <div>
                {hasConfirmationStep ? (
                  <button
                    data-testid="t-Funds-button-2"
                    className="round-btn secondary-color-background"
                    disabled={formIsValid}
                    onClick={() => !formSubmitting && updateAllocationsAmountWithGifts()}
                    title="donation-button"
                    type="submit">
                    {formSubmitting ? (
                      <i className="fa fa-2x fa-refresh fa-spin" />
                    ) : (
                      <FormattedMessage id="continue" />
                    )}
                  </button>
                ) : (
                  <button
                    data-testid="t-Funds-button-3"
                    className="round-btn secondary-color-background"
                    disabled={formIsValid}
                    onClick={() => {
                      updateAllocationsAmountWithGifts();
                      handleSubmit();
                    }}
                    title="donation-button"
                    type="submit">
                    {formSubmitting ? (
                      <i className="fa fa-2x fa-refresh fa-spin" />
                    ) : (
                      <FormattedMessage id="giveNow" />
                    )}
                  </button>
                )}
              </div>
              <div className="not-interested-section">
                {hasConfirmationStep ? (
                  <span
                    className="not-interested-btn"
                    onClick={() => {
                      resetCentralizedGifts(false);
                      handleConfirm();
                    }}>
                    <FormattedMessage id="notInterested" />
                  </span>
                ) : (
                  <span
                    className="not-interested-btn"
                    onClick={() => {
                      resetCentralizedGifts(false);
                      handleSubmit();
                    }}>
                    <FormattedMessage id="notInterested" />
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  const currentEntity = getEntity(state);

  return {
    confirming: getConfirming(state),
    formSubmitting: getFormSubmitting(state),
    allocations: getAllocations(state),
    entity: currentEntity,
    centralizedGifts: getCentralizedGifts(state),
    currencySymbol: currentEntity.get("currency_symbol"),
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Funds);
